import { MessageBox, Loading } from "element-ui";

/*
   时间戳转换
   new Date.format('yyyy-MM-dd h:m:s');
 */
window.Date.prototype.format = function(format) {
  let date = {
    "M+": this.getMonth() + 1,
    "d+": this.getDate(),
    "h+": this.getHours(),
    "m+": this.getMinutes(),
    "s+": this.getSeconds(),
    "q+": Math.floor((this.getMonth() + 3) / 3),
    "S+": this.getMilliseconds()
  };
  if (/(y+)/i.test(format)) {
    format = format.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in date) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1
          ? date[k]
          : ("00" + date[k]).substr(("" + date[k]).length)
      );
    }
  }
  return format;
};

const obj = {
  table: {
    time(val1, val2, val3) {
      if (val3) {
        return new Date(val3).format("yyyy-MM-dd hh:mm:ss");
      }
    }
  },
  time(val, str = "yyyy-MM-dd hh:mm:ss") {
    if (val) {
      return new Date(val).format(str);
    }
  },
  //删除空的参数
  signDel(res) {
    for (let key in res) {
      let item = res[key];
      if (item === null || item === undefined || item === "") {
        delete res[key];
      }
    }
    return res;
  },
  urlEnJson(res) {
    return encodeURIComponent(JSON.stringify(res));
  },
  urlDeJson(res) {
    return JSON.parse(decodeURIComponent(res));
  },
  codeExN(res, num) {
    let code = res ? res.toString(2) : "";

    if (num >= code.length) {
      return 0;
    } else {
      return Math.floor(code.substr(code.length - 1 - num, 1));
    }
  },
  stringEllipsis(str, n) {
    let xx = str.substring(0, n);
    return str.length > n ? xx + "..." : str;
  },
  videoTime(mss) {
    let h = parseInt((mss % (60 * 60 * 24)) / (60 * 60));
    let m = parseInt((mss % (60 * 60)) / 60);
    let s = mss % 60;

    if (h < 10) h = "0" + h;
    if (m < 10) m = "0" + m;
    if (s < 10) s = "0" + s;
    return h + ":" + m + ":" + s;
  },
  downTime(second_time) {
    if (!second_time) return 0;
    let time = parseInt(second_time) + "秒";

    if (parseInt(second_time) > 60) {
      let second = parseInt(second_time) % 60;
      let min = parseInt(second_time / 60);
      time = min + "分" + second + "秒";

      if (min > 60) {
        min = parseInt(second_time / 60) % 60;
        let hour = parseInt(parseInt(second_time / 60) / 60);
        time = hour + "小时" + min + "分" + second + "秒";

        if (hour > 24) {
          hour = parseInt(parseInt(second_time / 60) / 60) % 24;
          let day = parseInt(parseInt(parseInt(second_time / 60) / 60) / 24);
          time = day + "天" + hour + "小时" + min + "分" + second + "秒";
        }
      }
    }

    return time;
  },
  form: {
    phone(rule, value, callback) {
      if (obj.validate.phone(value)) {
        callback();
      } else if (rule.required || value) {
        callback(new Error("请输入有效的手机号码"));
      } else {
        callback();
      }
    },
    score(rule, value, callback) {
      if (obj.validate.score(value)) {
        callback();
      } else if (rule.required || value) {
        callback(new Error(rule.message));
      } else {
        callback();
      }
    },
    isCardNo(rule, value, callback) {
      if (obj.validate.isCardNo(value)) {
        callback();
      } else if (rule.required || value) {
        callback(new Error(rule.message));
      } else {
        callback();
      }
    },
    init(rule, value, callback) {
      value = String(value);
      let reg = /^-?[1-9]\d*$/;
      if (value.match(reg)) {
        callback();
      } else if (rule.required === true || (rule.required !== true && value)) {
        callback(new Error("请填写数值"));
      } else {
        callback();
      }
    }
  },
  validate: {
    score: val => {
      let reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/;
      return String(val).match(reg);
    },
    //正整数
    intP: val => {
      let reg = /^[1-9]\d*$/;
      return String(val).match(reg);
    },
    //手机
    phone: val => {
      // let reg = /^1[3456789]\d{9}$/;
      let reg = /^\d{11}$/;
      return !!String(val).match(reg);
    },
    //身份证
    isCardNo: val => {
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X)$)/;
      return String(val).match(reg);
    }
  },
  confirm(text = "确定要删除吗？", title = "提示") {
    console.log(text);
    return MessageBox.confirm(text, title, {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
  },
  loading: {
    show(background = "rgba(255, 255, 255, 0.4)") {
      this.loading = Loading.service({
        background
      });
    },
    hide() {
      if (this.loading) this.loading.close();
    }
  },
  winBeforeAdd(str = "您还未保存报告，确定要离开当前页面？") {
    window.onbeforeunload = e => {
      let evt = e ? e : window.event ? window.event : null;
      evt.returnValue = str;
      return str;
    };
  },
  winBeforeRemove() {
    window.onbeforeunload = () => {};
  },
  downFile(url, fileName = "") {
    let temArr = url.split("/");
    let temName = temArr[temArr.length - 1];
    let kzArr = temName.split(".");
    let kzName = kzArr[kzArr.length - 1];

    temName = temName.replace("." + kzName, "");

    if (!fileName) fileName = temName;

    location.href = `${url}?attname=${fileName}.${kzName}`;
  },
  ifHttpUrl(url = "") {
    if (url) {
      return url.slice(0, 4) === "http";
    }
  }
};

export default obj;
